module.exports = __webpack_public_path__ + "static/media/logs.9bb11385.svg";